/* Read current market prices from this theme only. No Admin credentials or vendor calls. */
(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('ceika-vehicle-data-config')?.textContent || '{}');
  const cache = new Map(); let active = 0; const waiting = [];
  const root = (config.root || '/').replace(/\/$/, '');
  function localURL(path) {
    const url = new URL(root + '/' + path.replace(/^\//, ''), location.origin);
    const preview = String(new URL(location.href).searchParams.get('preview_theme_id') || config.previewThemeId || '');
    if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
    return url;
  }
  async function product(handle, signal) {
    if (!/^[a-zA-Z0-9_-]{1,250}$/.test(handle || '')) return null;
    if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
    if (cache.has(handle)) return cache.get(handle);
    if (active >= 4) await new Promise(resolve => waiting.push(resolve));
    active++;
    const controller = new AbortController();
    const cancel = () => controller.abort(); signal?.addEventListener('abort', cancel, {once:true});
    const deadline = setTimeout(cancel, 9000);
    try {
      if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
      const url = localURL('products/' + encodeURIComponent(handle)); url.searchParams.set('view','ceika-vehicle-card');
      const response = await fetch(url, {signal:controller.signal,credentials:'same-origin',headers:{Accept:'text/html'}});
      if (!response.ok) return null;
      const data = await response.json();
      if (data.handle !== handle || data.currency !== config.currency || !Number.isSafeInteger(data.price) || data.price < 0) return null;
      if (cache.size > 150) cache.delete(cache.keys().next().value);
      cache.set(handle, data); return data;
    } catch (error) { if(signal?.aborted) throw error; return null; }
    finally { clearTimeout(deadline);signal?.removeEventListener('abort',cancel);active--;waiting.shift()?.(); }
  }
  async function enrich(groups, vehicle, context, signal, options) {
    return Promise.all(groups.map(async group => {
      const out = {...group,price:null,startingPrice:null,reviewCount:null,singleProductURL:null};
      let handles = [], complete = true;
      if (group.key === 'wheels') handles = [options.wheelHandle];
      else if (group.matchedProductCount > 0) {
        const data = await window.CeikaVehicleData.request('/api/v1/products',{vehicle_id:vehicle.id,...(vehicle.year?{year:vehicle.year}:{}),family:group.key,limit:20,offset:0},signal);
        handles = [...new Set(data.products.map(p=>p.handle))];
        complete = Number.isSafeInteger(data.total) && handles.length === data.total;
        if(complete)out.matchedProductCount=data.total;
      }
      if (!handles.length || !complete) return out;
      const entries = await Promise.all(handles.map(handle=>product(handle,signal)));
      if (entries.some(p=>!p || !p.available || p.price <= 0)) return out;
      if(group.key!=='wheels' && entries.length===1)out.singleProductURL=localURL('products/'+entries[0].handle).href;
      const best = entries.reduce((a,b)=>a.price<=b.price?a:b);
      if (config.currencyAligned) out.startingPrice = {amountMinor:best.price,currency:best.currency,formatted:best.priceFormatted,basis:group.key==='wheels'?'wheel':group.key==='brakes'?'axle kit':'kit'};
      if (Number.isSafeInteger(best.reviewCount) && best.reviewCount > 0) {
        out.reviewCount=best.reviewCount;out.reviewScope='listing';out.reviewURL=localURL('products/'+best.handle).href+'#judgeme_product_reviews';
      }
      return out;
    }));
  }
  window.CeikaVehicleShopify = {product,enrich,localURL};
})();
